<table class="table">
  <thead>
    <tr>
      <th>{{ "common.productVariant" | translate }}</th>
      <th>{{ "requestPurchase.sku" | translate }}</th>
      <th>{{ "Expected date" | translate }}</th>
      <th>{{ "inbounding.remainingDays" | translate }}</th>
      <th>{{ "Quantity Needed" | translate }}</th>
      <th>{{ "Quantity Fulfilled" | translate }}</th>
    </tr>
  </thead>
  <tbody *ngIf="inbound$ | async as inbound">
    <ng-container *ngIf="inbound">
      <tr *ngFor="let request of inbound.group.requests">
        <td class="flex flex-row">
          <a
            class="button-ghost"
            [routerLink]="[
              '/catalog/products',
              request.productVariant.product.id
            ]"
          >
            <span>
              {{ request.productVariant.name }}
            </span>
            <clr-icon shape="arrow right" />
          </a>

          <div
            *ngIf="request.productVariant.product.customFields.freeGifts"
            class="freegift-badge button-ghost"
          >
            Free gift <clr-icon shape="shopping-bag" />
          </div>
        </td>
        <td>{{ request.productVariant.sku }}</td>
        <td>{{ request.quantityNeeded }}</td>
        <td *ngIf="request.expectedDate">
          {{ request.expectedDate | localeDate : "short" }}
        </td>
        <td *ngIf="!request.expectedDate">*</td>

        <td>{{ request.daysLate }}</td>
        <td>{{ request.quantityFulfilled }}</td>
      </tr>
    </ng-container>
  </tbody>
</table>
